export default {
  meta: {
    title: '审批详情',
    url: '/expandstore/approver', // 埋点用，记录所属模块
    parentPath: ['/expandstore/approver'],
    breadcrumbs: {
      path: ['/expandstore/approver'], // 该模块首页
      name: ['审批详情'],
    },
  },
};
